var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-vertical-chart-container"},[_c('h3',[_vm._v(_vm._s(_vm.$t( _vm.subtitle)))]),_c('div',{staticClass:"vertical-chart",attrs:{"id":_vm.alias}})])
}
var staticRenderFns = []

export { render, staticRenderFns }